module.exports = __webpack_public_path__ + "static/media/test10_4.3530f0fd.png";